import { JobseekerModel } from '../shared/models/jobseeker-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { JobseekerEducationModel } from '../shared/models/jobseeker-education-model';
import { EducationLevelModel } from '@admin/shared/models/education-level-model';
import { EducationalInstitutionModel } from '@admin/shared/models/educational-institution-model';
import { EducationalProgramModel } from '@admin/shared/models/educational-program-model';

@Component({
  selector: 'hr-jobseeker-education-info',
  templateUrl: './jobseeker-education-info.component.html',
  styleUrls: ['./jobseeker-education-info.component.less'],
  standalone: false,
})
export class JobseekerEducationInfoComponent implements OnInit {
  @Input()
  public jobseeker: JobseekerModel;

  public newEducation: JobseekerEducationModel;
  public isAddModeOn: boolean;

  constructor() {
    this.isAddModeOn = false;
    this.newEducation = null;
  }

  @Output()
  public onUpdate: EventEmitter<boolean> = new EventEmitter<boolean>();

  public onEducationUpdate() {
    this.onUpdate.emit(true);
  }

  public onCancelAddEducation() {
    this.isAddModeOn = false;
  }

  public onEducationAdded(event) {
    this.isAddModeOn = false;
    this.onUpdate.emit(true);
  }

  public onAddClick() {
    this.resetNewEducation();
    this.isAddModeOn = true;
  }

  ngOnInit() {}

  private resetNewEducation() {
    this.newEducation = new JobseekerEducationModel();
    this.newEducation.jobseekerId = this.jobseeker.jobseekerId;
    this.newEducation.jobseekerEducationId = -1;
    this.newEducation.educationLevel = new EducationLevelModel();
    this.newEducation.educationalInstitution =
      new EducationalInstitutionModel();
    this.newEducation.educationalProgram = new EducationalProgramModel();
  }
}
